import { Config, makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import { ICCPARequest } from '@/types';

const makeCCPAService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        getRequestTypes: async (config?: Config) => {
            const res = await fetcher.get('/request-types', config);
            const data = (await res.json()) as number[];
            return data;
        },

        submitForm: async (formData: ICCPARequest) => {
            const res = await fetcher.post('/', JSON.stringify(formData));
            return res.status;
        },
    };
};

export const ccpaService = makeCCPAService(config.api.url.ccpa);
